import { useGetDocumentOrderFilterDimensions } from "hooks/api/documents/documentFilterDimensions";
import useSelectedCustomerCode from "hooks/useSelectedCustomerCode";
import { removeNullable } from "services/apiHelpers";
import {
  CheckboxListFilter,
  FilterOption,
} from "../GenericFilters/CheckboxListFilter";
import { FilterProps } from "../filter-definition";

export const OrdersSalesTermsFilter = ({ variant }: FilterProps) => {
  const cardCodes = useSelectedCustomerCode();

  const { data, isLoading } = useGetDocumentOrderFilterDimensions(cardCodes);

  const salesTermsOptions: FilterOption[] = removeNullable(
    data?.salesTerms?.map((salesTerm) => ({
      label: salesTerm.Name,
      value: salesTerm.Code,
    })) ?? []
  );

  return (
    <CheckboxListFilter
      filterKey="salesTerms"
      name="Sales Terms"
      variant={variant}
      filterOptions={salesTermsOptions}
      isLoading={isLoading}
    />
  );
};
